import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import FetchOnSubmit from "components/Library/FetchOnSubmit";
import NewsletterSubscribeForm from "components/Library/NewsletterSubscribeForm";
import NewsletterPromoSuccess from "components/Library/NewsletterPromoSuccess";
import Icon from "components/Library/Icon";
import { promoInViewDataLayerEvent, optimizeActivate } from "utils/analytics";
import { setStreamCapPromoBlockedCookie } from "stream/utils/streamCapCookie";
import { FETCH_STATUS } from "config/constants";

import styles from "./SubscribeStreamCap.css";

class SubscribeStreamCap extends Component {
  constructor(props) {
    super(props);
    this.state = { isDismissed: false };
    this.dismiss = this._dismiss.bind(this);
    this.onSuccess = this._onSuccess.bind(this);
  }

  componentDidMount() {
    optimizeActivate();
    promoInViewDataLayerEvent("stream_cap_nl_promo", this.props.promo);
  }

  _dismiss() {
    this.setState({ isDismissed: true });
    setStreamCapPromoBlockedCookie(true, { expires: 7 });
  }

  _onSuccess() {
    setStreamCapPromoBlockedCookie(true, { expires: 30 });
  }

  render() {
    const { promo } = this.props;

    if (this.state.isDismissed) {
      return null;
    }

    return (
      <div
        className={classNames(styles.root, "gtm-stream-cap-nl-promo")}
        style={{ backgroundColor: promo.backgroundColor }}
      >
        <div className={styles.content}>
          <FetchOnSubmit
            method="POST"
            url="/readers/unauth-sub/"
            onSuccess={this.onSuccess}
          >
            {({ status, error, submit, reset }) => {
              return (
                <React.Fragment>
                  <div aria-live="polite" role="status">
                    {status === FETCH_STATUS.SUCCESS && (
                      <div
                        className={styles.successOverlay}
                        style={{ backgroundColor: promo.backgroundColor }}
                      >
                        <NewsletterPromoSuccess />
                      </div>
                    )}
                  </div>
                  <div aria-hidden={status === FETCH_STATUS.SUCCESS}>
                    <h4 className={styles.title}>{promo.title}</h4>
                    <div className={styles.form}>
                      <NewsletterSubscribeForm
                        list={promo.list}
                        userVars={{
                          campaign: "stream_cap_cta_direct_email_input",
                        }}
                        formClassName="gtm-newsletter-promo-stream-cap"
                        disableBorder={true}
                        buttonColor="#222"
                        placeholder={promo.placeholder}
                        status={status}
                        submit={submit}
                        reset={reset}
                        error={error}
                      />
                    </div>
                  </div>
                </React.Fragment>
              );
            }}
          </FetchOnSubmit>
        </div>

        {promo.image && (
          <img className={styles.image} src={promo.image} alt="" />
        )}

        <button
          className={styles.dismiss}
          aria-label="Dismiss promotion"
          onClick={this.dismiss}
        >
          <Icon name="close-thin" description="Close" className={styles.icon} />
        </button>
      </div>
    );
  }
}

SubscribeStreamCap.propTypes = {
  promo: PropTypes.shape({
    title: PropTypes.string.isRequired,
    list: PropTypes.string.isRequired,
    image: PropTypes.string,
    placeholder: PropTypes.string,
    backgroundColor: PropTypes.string,
  }).isRequired,
};

export default SubscribeStreamCap;
